<header>
  <div class="menu-icon" (click)="togglSideFilters()">
    <img src="assets/img-svg/menu.png" alt="">
  </div>
  <!-- <div class="languages-container">
    <ul class="languages">
      <li [ngClass]="{'active': currentLanguage === languageId.SPANISH}" (click)="selectLanguage(languageId.SPANISH)">ES</li>
      <li [ngClass]="{'active': currentLanguage === languageId.ENGLISH}" (click)="selectLanguage(languageId.ENGLISH)">EN</li>
      <li [ngClass]="{'active': currentLanguage === languageId.FRENCH}" (click)="selectLanguage(languageId.FRENCH)">FR</li>
    </ul>
  </div> -->
  <img src="assets/img-svg/logo-visemar.png" alt="Logo">  
  <!-- <h1>IDStone</h1> -->
</header>